import { styled } from '@volkswagen-onehub/components-core';

export const StyledGalleryViewerCarousel = styled.div`

  background: linear-gradient(0deg, #E8E3D9 0.11%, rgba(232, 227, 217, 0) 75.62%);
  background-blend-mode: multiply;
`;
